// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__3ih0X","imageHolder":"AboutUs_imageHolder__UbXyJ","textHolder":"AboutUs_textHolder__7mrPN"};